module.exports = __webpack_public_path__ + "img/phase-active.508951ec.png";